export default {
  halfWidth: {
    width: '50%',
    display: 'inline-block'
  },
  leftSide: {
    width: '50%',
    display: 'inline-block',
    paddingRight: '1rem'
  },
  container: {
    paddingBottom: '.8rem',
    '& input[type=number]': {
      '-moz-appearance': 'textfield',
      '&::-webkit-outer-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0
      },
      '&::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0
      }
    }
  },
  displayOverlay: {
    '& label': {
      display: 'inline-block',
      marginLeft: '.5rem',
      fontWeight: 'normal',
      verticalAlign: -1,
      marginTop: '1rem'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/AdvancedPanelContainer/style.js